export default `
	social {
		...on SocialItem {
			instagram
		}
	}
`;
